const ITEMS = [
  "DPDP Act 2023",
  "IT Act 2000",
  "NIN Dietary Guidelines",
  "FSSAI",
  "Clinical Establishments Act 2010",
  "Data Localised · AWS Mumbai",
  "AES-256 · TLS 1.3",
];

export default function ComplianceStrip() {
  const doubled = [...ITEMS, ...ITEMS];
  return (
    <section
      data-testid="compliance-strip"
      className="border-y border-border bg-secondary py-8 overflow-hidden"
    >
      <div className="mx-auto max-w-7xl px-6 mb-6">
        <p className="font-mono text-[11px] uppercase tracking-widest text-secondary">
          Built in compliance with
        </p>
      </div>
      <div className="relative">
        <div className="flex gap-16 whitespace-nowrap animate-marquee">
          {doubled.map((label, i) => (
            <span
              key={i}
              className="font-mono text-sm uppercase tracking-widest text-foreground/70 shrink-0"
            >
              — {label}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
